// 历史记录
export default {
    playback: 'Воспроизведение истории',
    flyrecords: 'полётная запись',
    flyplay: 'Воспроизведение полетной записи',
    video: 'видео',
    photo: 'Фото',
    shoottime: 'Время съемки',
    min: 'минимальный',
    max: 'максимум',
    select: "Выбрать",
    manydowland: 'Пакетная загрузка',
    photosize: 'Размер изображения',
    videosize: 'Продолжительность видео',
    download: 'скачать',
    manydelophoto: 'Эта операция навсегда удалит выбранное изображение, продолжать ли',
    videoplay: 'Проигрывание видео',
    delovideo: 'Эта операция приведет к безвозвратному удалению этого видео. продолжать ли?',
    mustthree: 'Вы можете скачать не более трех',
    manydelovideo: 'Эта операция навсегда удалит выбранное видео, продолжать ли',
    tip_err1: 'В настоящее время ограничен выбор до 99 файлов, в этот раз выбрано {0} файла.',
    tip_err2: 'Ошибка формата изображения, пожалуйста, загрузите его снова!',
    tip_err3: 'Размер изображения не должен превышать 10 Мб!',
}